import { useParams } from "react-router-dom";

export const useUserIdFromParams = () => {
  const { id } = useParams();
  return { userId: id };
};
